import React from 'react';
import LightEffects from './LightEffects';

const About = () => {
  return (
    <section id="about" className="relative bg-black py-24 md:py-32">
      {/* Light Effects */}
      <LightEffects variant="lasers" />
      
      <div className="container mx-auto px-[7.6923%]">
        <div className="max-w-5xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-5xl md:text-6xl font-semibold text-white mb-6 tracking-tight">
              About LFXPro Lights
            </h2>
            <div className="h-1 w-24 bg-blue-500 mx-auto mb-6"></div>
          </div>

          {/* Content */}
          <div className="space-y-12">
            {/* Main Description */}
            <div className="text-center">
              <p className="text-xl text-white/85 leading-relaxed mb-6">
                LFXPro Lights delivers premium professional lighting solutions that transform environments and create unforgettable experiences. With a commitment to excellence and precision engineering, we serve the world's most demanding applications.
              </p>
              <p className="text-lg text-white/70 leading-relaxed">
                From intimate club installations to massive festival stages, architectural landmarks to broadcast studios, our lighting systems are trusted by professionals worldwide.
              </p>
            </div>

            {/* Key Points Grid */}
            <div className="grid md:grid-cols-3 gap-8 mt-16">
              <div className="text-center p-8 bg-gradient-to-br from-white/5 to-transparent border border-white/10">
                <div className="text-4xl font-bold text-blue-500 mb-3">15+</div>
                <p className="text-base text-white/70">Years of Excellence</p>
              </div>
              <div className="text-center p-8 bg-gradient-to-br from-white/5 to-transparent border border-white/10">
                <div className="text-4xl font-bold text-blue-500 mb-3">50+</div>
                <p className="text-base text-white/70">Countries Worldwide</p>
              </div>
              <div className="text-center p-8 bg-gradient-to-br from-white/5 to-transparent border border-white/10">
                <div className="text-4xl font-bold text-blue-500 mb-3">1000+</div>
                <p className="text-base text-white/70">Premium Installations</p>
              </div>
            </div>

            {/* Engineering Excellence */}
            <div className="bg-gradient-to-r from-blue-900/20 to-transparent border-l-4 border-blue-500 p-8 mt-12">
              <h3 className="text-2xl font-semibold text-white mb-4">
                Engineered in Germany
              </h3>
              <p className="text-base text-white/70 leading-relaxed">
                Our research and development facility in Garching bei München, Germany, is the heart of our innovation. Here, our team of lighting engineers and designers develop cutting-edge solutions that push the boundaries of what's possible in professional lighting. Every product bearing the LFXPro name represents German engineering excellence, uncompromising quality, and meticulous attention to detail.
              </p>
            </div>

            {/* Applications */}
            <div className="mt-12">
              <h3 className="text-2xl font-semibold text-white mb-6 text-center">
                Applications
              </h3>
              <div className="flex flex-wrap justify-center gap-4">
                {['Concerts', 'Festivals', 'Theaters', 'Clubs', 'Architectural Lighting', 'TV Studios', 'Corporate Events', 'Houses of Worship', 'Theme Parks', 'Cruise Ships'].map((app, index) => (
                  <span
                    key={index}
                    className="px-5 py-3 bg-white/5 text-white border border-white/10 text-sm hover:border-blue-500/50 transition-colors duration-300"
                    style={{ borderRadius: '0px' }}
                  >
                    {app}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
